module.exports = __webpack_public_path__ + "static/img/y17.e161657.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y17.jpg
// module id = AM3u
// module chunks = 1